'use client'

import {useEffect, useState} from 'react'

// Hook to track hash changes in the URL
// https://github.com/vercel/next.js/discussions/49465#discussioncomment-11975480
export const useHash = () => {
  const getHash = () => (typeof window !== 'undefined' ? window.location.hash : '')

  const [hash, setHash] = useState(getHash())

  useEffect(() => {
    const onHashChanged = () => {
      setHash(getHash())
    }
    const {pushState, replaceState} = window.history
    window.history.pushState = function (...args) {
      pushState.apply(window.history, args)
      setTimeout(() => {
        setHash(getHash())
      })
    }
    window.history.replaceState = function (...args) {
      replaceState.apply(window.history, args)
      setTimeout(() => {
        setHash(getHash())
      })
    }
    window.addEventListener('hashchange', onHashChanged)
    return () => {
      window.removeEventListener('hashchange', onHashChanged)
    }
  }, [])
  return hash
}
